import httpClient from "./httpClient";

const prefix = "/periodicities";

export async function paginatePeriodicidad(query: string) {
  return ( await httpClient.get( `${prefix}/list-paginated?${query}`)).data;
}

export async function updatePeriodicidad(id: number, data: any) {
  return (await httpClient.patch(`${prefix}/${id}`, data)).data;
}

export async function deletePeriodicidad(id: number) {
  return (await httpClient.delete(`${prefix}/${id}`)).data;
}

export async function readPeriodicidad(id: number) {
  return (await httpClient.get(`${prefix}/${id}`)).data;
}

export async function savePeriodicidad(data: any) {
  return (await httpClient.post(prefix, data)).data;
}
